import React from 'react';
import * as S from '../terms.style';

/* eslint-disable */
export const responsabilityTerm = () => {
  document.title = "Plataforma | Termo de responsabilidade";

  return (
    <S.Container>
      <S.Title1>Termo de responsabilidade</S.Title1>

      <S.Updated>Última atualização: 27 de novembro de 2020</S.Updated>

      <S.Text>
        Pelo presente <S.Span bold>Termo de Responsabilidade</S.Span>, a
        empresa, daqui em diante denominada apenas como “CORRETORA DE SEGUROS”
        (“”), por seu(s) representante(s), assume(m) a(s) responsabilidade(s)
        pelo uso do sistema, denominado “Plataforma do Corretor”, da Junto
        Seguros S.A. (“SEGURADORA”), de acordo com as disposições a seguir:
      </S.Text>

      <S.Text>
        1. É objeto do presente <S.Span bold>Termo de Responsabilidade</S.Span> a assunção de responsabilidade pela CORRETORA DE SEGUROS frente à
        SEGURADORA, na utilização da Plataforma do Corretor, para os fins que
        ela se dispõe no relacionamento de negócios especificamente ao produto
        de Seguro Garantia, ou seja: cotações, registros de propostas e emissões
        de apólices e/ou endossos, entre outras funcionalidades disponíveis para
        gestão do produto de seguro supramencionado.
      </S.Text>

      <S.Text>
        1.1. Mediante aceite expresso na Plataforma do Corretor, a CORRETORA DE
        SEGUROS declara de forma inequívoca que aceita e não limitará esforços
        para o alcance da conformidade às disposições do presente Termo de
        Responsabilidade, bem como, no atendimento das legislações e disposições
        regulatórias vigentes, em especial àquelas emitidas pela
        Superintendência de Seguros Privados (SUSEP), no que tange as atividades
        de corretores de seguros durante o relacionamento comercial e de
        negócios com a SEGURADORA, e da mesma forma, durante todo o ciclo de
        vida da apólice de seguro contratada pelo Tomador e Segurado, através da
        intermediação da CORRETORA DE SEGUROS.
      </S.Text>

      <S.Text>
        2. Visando utilizar-se da Plataforma do Corretor, a CORRETORA DE SEGUROS
        deverá realizar o pré-cadastro através do preenchimento das informações
        solicitadas pela SEGURADORA, assegurando a validade das informações
        apresentadas e que reflitam a temporalidade dos dados ali dispostos. É
        dever da CORRETORA DE SEGUROS comunicar à SEGURADORA imediatamente
        quando houver qualquer alteração em seus dados cadastrais.
      </S.Text>

      <S.Text>
        2.1. A SEGURADORA, a seu exclusivo critério, poderá ou não autorizar o
        uso da Plataforma do Corretor e prover à CORRETORA DE SEGUROS um
        registro de login e senha específicos para acesso à referida Plataforma.
      </S.Text>

      <S.Text>
        2.2. A CORRETORA DE SEGUROS garante a devida confidencialidade do login
        e senha de acesso a Plataforma do Corretor através da implementação de
        controles internos eficazes, sendo vedado o compartilhamento com
        terceiros não autorizados pela SEGURADORA e assume, ainda, total
        responsabilidade pelo uso correto e lícito da citada Plataforma.
      </S.Text>

      <S.Text>
        3. Fica acordado entre as partes que o login e a senha substituirão para
        todos os fins a assinatura na proposta de Seguro Garantia, em
        conformidade com as disposições regulatórias vigentes emitidas pela
        Superintendência de Seguros Privados (SUSEP), em especial às resoluções
        do Conselho Nacional de Seguros Privados (CNSP), no que tange a norma de
        conduta e de meios remotos.
      </S.Text>

      <S.Text>
        3.1. A CORRETORA DE SEGUROS reconhece e possui ciência de que a
        autorização de acesso a Plataforma do Corretor não garante a aceitação
        tácita de proposta de emissão de apólices e/ou endossos de seguro
        garantia, por esta SEGURADORA. A aceitação de riscos da cobertura
        securitária decorre da observância e análise dos parâmetros dos produtos
        ofertados, apetite a riscos e dentre outras informações indispensáveis
        no processo de subscrição desta SEGURADORA.
      </S.Text>

      <S.Text>
        4. Caso a SEGURADORA não forneça login e senha à CORRETORA DE SEGUROS,
        no prazo máximo de até 24 horas contados a partir da conclusão de seus
        registros cadastrais, restará caracterizada, para todos os fins, a
        recusa da SEGURADORA ao pedido de acesso.
      </S.Text>

      <S.Text>
        5. A SEGURADORA tem tolerância zero para desconformidades com as
        diretrizes estabelecidas neste <S.Span bold>Termo de Responsabilidade</S.Span>,
        estando a CORRETORA DE SEGUROS, na medida da apuração de suas responsabilidades, sujeita a
        reparação de danos à SEGURADORA e a terceiros prejudicados, respondendo
        civil e criminalmente pela inobservância das leis, dos regulamentos e
        das resoluções em vigor, pela ação ou omissão, dolosa ou culposa,
        inclusive, em razão do uso inadequado ou contrário aos objetivos da
        Plataforma citado no presente Termo.
      </S.Text>

      <S.Text>
        6. A CORRETORA DE SEGUROS reconhece e concorda que (i) todas as
        informações constantes na Plataforma do Corretor, bem como suas
        características, funcionalidades, capacidades e diretrizes são de
        caráter confidencial, tendo certa e acordada a responsabilidade de não
        as divulgar sob qualquer pretexto, bem como que (ii) a propriedade
        intelectual integral do sistema é e permanecerá sendo da SEGURADORA,
        para todos os fins de direito. A SEGURADORA, através deste e mediante o
        seu aceite expresso, confere à CORRETORA DE SEGUROS o direito de uso da
        Plataforma, nos termos aqui definidos. Uma vez encerrado o
        relacionamento entre as partes, ficará também extinto tal direito de
        uso, imediatamente.
      </S.Text>

      <S.Text>
        7. A CORRETORA DE SEGUROS reconhece que todas as informações de contato
        prestadas por ela na Plaforma do Corretor, bem como aquelas
        eventualmente recebidas por correspondência postal, e-mail ou similares
        poderão ser utilizadas pela SEGURADORA para: (i)o envio de boletos de
        cobrança de prêmio de seguro, materiais informativos e de publicidade
        e/ou mensagens de educação financeira e securitária, bem como, (ii) no
        compartilhamento com entidades seguradoras e resseguradoras, corretoras
        de seguro e resseguro e acionistas diretos ou indiretos da SEGURADORA
        que precisem receber tais informações para os fins de mediação e
        contratação de apólice de Seguro Garantia, observados os termos da Lei
        13.709/18 (Lei Geral de Proteção de Dados, Lei 12.965/14 e Lei
        13.709/18., e suas eventuais atualizações.
      </S.Text>

      <S.Text>
        8. Sem prejuízo ao disposto nos itens anteriores do presente <S.Span bold>Termo de Responsabilidade</S.Span>, a CORRETORA DE SEGUROS,
        ainda, assume integralmente a reponsabilidade pelos dados e informações
        fornecidos na Plataforma do Corretor, sendo a SEGURADORA isenta de
        quaisquer responsabilidades decorrentes do uso destas informações em
        propostas e/ou emissões de apólices e/ou endossos de Seguro Garantia, as
        quais, se errôneas, podem resultar em impugnações e/ou inabilitação em
        Certames Licitatórios, Contratos com a Administração Pública ou
        Processos Judiciais.
      </S.Text>

      <S.Text>
        9. Os produtos de seguros ofertados pela SEGURADORA estão aprovados e
        registrados pela Superintendência de Seguros Privados (SUSEP)
        edisponíveis para consulta através da página da internet
        (<a href="http://www.susep.gov.br/" target="_blank"> www.susep.gov.br</a>).
      </S.Text>

      <S.Text>
        10. Em conformidade com as melhores práticas de mercado, a SEGURADORA
        possui disponível em sua página da internet
        (<a href="https://www.juntoseguros.com/" target="_blank">www.juntoseguros.com</a>)
        um Código de Ética e Conduta com diretrizes específicas para a
        CORRETORA DE SEGUROS, com referências à normas regulatórias, em
        especial, a norma de conduta e de atendimento ao cliente. É recomendado
        o acesso e leitura ao referido Código, estadando o departamento de
        Compliance da SEGURADORA disponível para eventuais esclarecimentos,
        através do e-mail compliance@juntoseguros.com.
      </S.Text>

      <S.Text>
        11. O presente Termo será regido de acordo com as leis da República
        Federativa do Brasil. Em caso de conflito, as partes elegem o Foro
        Central da Comerca de Curitiba, PR, por mais privilegiado que outro
        seja. Declaro, portanto, ter ciência e estar de acordo com as
        disposições deste <S.Span bold>Termo de Responsabilidade</S.Span> comprometendo-me a respeitá-las e cumpri-las plena e integralmente.
      </S.Text>
    </S.Container>
  );
};
/* eslint-enable */
